import SiteRender from '@/views/microSite/core/components/render/siteRender'
import { MICRO_SITE_TYPE } from '@/constant/common'
import _ from 'lodash'

// route config in @/views/microSite/route.js
export default {
  extends: SiteRender,
  data () {
    return {
      logo: {
        show: false,
        path: ''
      },
      homePath: null
    }
  },
  computed: {
    type () {
      return MICRO_SITE_TYPE.onboarding
    }
  },
  created () {
    this.pathPrefix = `/v-admin/onboarding-management/micro-site/detail/${this.siteId}`
    this.initEventBus()
    this.initSitePages().then((resp) => {
      this.logo.show = true
      this.logo.path = resp.originResponse.company_logo
      const pageData = _.find(this.sitePages, 'isIndex')
      if (pageData && pageData.status.show) {
        this.homePath = `${this.pagePathPrefix}${pageData.path}`
      }
    })
  },
  methods: {
    initEventBus () {
      this.$eventBus.$on('getMicroSiteNavigationLogo', callback => {
        callback(this.logo)
      })
      this.$eventBus.$on('microSiteNavigationLogoClick', this.onLogoClick)
    },
    onLogoClick () {
      if (this.homePath !== this.$route.path) {
        this.$router.push(this.homePath)
      }
      this.$eventBus.$emit('setSelectMenuItem', 0)
    }
  }
}
